import { render, staticRenderFns } from "./basketballData.vue?vue&type=template&id=58aaa2e2&scoped=true&"
import script from "./basketballData.vue?vue&type=script&lang=js&"
export * from "./basketballData.vue?vue&type=script&lang=js&"
import style0 from "./basketballData.vue?vue&type=style&index=0&id=58aaa2e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aaa2e2",
  null
  
)

export default component.exports